import { UploadUsersComponent } from './pages/upload-users/upload-users.component';
import { authGuard } from './core/guards/auth.guard';
import { redirectGuard } from './core/guards/redirect.guard';
import { Routes } from '@angular/router';
import { MainLayoutComponent } from './pages/layouts/main-layout/main-layout.component';
import { content } from './shared/routes/content.routes';
import { Error404Component } from './pages/error/error404/error404.component'


export const App_Route: Routes = [
  //{ path: '/upload-users', component: UploadUsersComponent},
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: '',
    canActivate: [redirectGuard],
    loadChildren: () =>
      import('./shared/routes/auth.routes').then((m) => m.authentication),
  },
  { path: '', component: MainLayoutComponent, canActivate:[authGuard], children: content },
  { path: 'public/users/register', component: UploadUsersComponent},
  { path: '**', component: Error404Component },
];
